import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
  ],
});

Font.register({
  family: 'WeIconFont',
  src: '/we-icons.ttf',
});

export const styles = StyleSheet.create({
  page: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
  },
  leftColumn: {
    position: 'relative',
    width: '48%',
    height: '100%',
    color: 'white',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
    paddingRight: 0,
  },
  rightColumn: {
    width: '52%',
    height: '100%',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    paddingTop: 150,
    paddingLeft: 0,
    paddingRight: 40,
  },
  sessionDescription: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.3,

    marginTop: 30,
    marginBottom: 30,
    width: '85%',

    maxLines: 3,
    textOverflow: 'ellipsis',
  },
  speakerImage: {
    position: 'absolute',
    bottom: 30,
    left: -10,
    width: 720,
    height: 740,
    objectFit: 'cover',
  },
  speakerName: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 16,
    fontWeight: 900,
    lineHeight: 1.5,
  },
  speakerJobTitle: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 1.4,
  },
  title: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 40,
    fontWeight: 700,
    marginBottom: 3,
    textTransform: 'uppercase',
  },
  subtitle: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 14,
    fontWeight: 400,
  },
  socialIconsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 15,
    marginTop: 20,
  },
  iconWhite: {
    color: 'white',
    cursor: 'pointer',
    fontFamily: 'WeIconFont',
    fontSize: 20,
  },
});
